module.exports = __webpack_public_path__ + "static/media/CrossBlur.e627114e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/CrossBlur.svg
// module id = 155
// module chunks = 0